import {enumDef} from "@/common/enumDefs";
import {localization} from "@/common/lang/localization";

const statusOptions= {
	fullyPaid: {
		code: "fully_paid",
		name: localization.i18n.t("PayImgInfo.full.paid")
	},
	unpaidBeforeDueDate: {
		code: "unpaid_before_due_date",
		name: localization.i18n.t("PayImgInfo.full.noPayments")
	},
	unpaidAfterDueDate: {
		code: "unpaid_after_due_date",
		name: localization.i18n.t("PayImgInfo.full.noPayments")
	},
	partiallyPaidBeforeDueDate: {
		code: "partially_paid_before_due_date",
		name: localization.i18n.t("PayImgInfo.full.partially")
	},
	partiallyPaidAfterDueDate: {
		code: "partially_paid_after_due_date",
		name: localization.i18n.t("PayImgInfo.full.partially")
	},
	willBeFullyPaid: {
		code: "will_be_fully_paid",
		name: localization.i18n.t("PayImgInfo.full.partially")
	},
	revoked: {
		code: "revoked",
		name: localization.i18n.t("PayImgInfo.full.revoked")
	},

	isFullyPaid(statusCode) {
		return statusCode === this.fullyPaid.code;
	},

	isPartiallyPaid(statusCode) {
		return statusCode === this.partiallyPaidBeforeDueDate.code || statusCode === this.partiallyPaidAfterDueDate.code;
	},

	isUnpaid(statusCode) {
		return statusCode === this.unpaidBeforeDueDate.code || statusCode === this.unpaidAfterDueDate.code;
	},

	isRevoked(statusCode) {
		return statusCode === this.revoked.code;
	},

	isToBeFullyPaid(statusCode) {
		return statusCode === this.willBeFullyPaid.code;
	}
};

function getStatusForSettlement(dueDate, paymentStatus, amountAlreadyPaid, amountRequested, amountExpected) {
	let now = moment().format("YYYY-MM-DD");
	let isBeforeDueDate = dueDate ? moment(now).isBefore(moment(dueDate)) : true;

	if (enumDef.paymentStatus.isSettled(paymentStatus)) {
		return statusOptions.fullyPaid;
	} else if (paymentStatus === enumDef.paymentStatus.Revoked) {
		return statusOptions.revoked;
	}
	else if (amountRequested > 0) {
		if (amountRequested + amountAlreadyPaid > amountExpected) {
			return statusOptions.willBeFullyPaid;
		} else if (isBeforeDueDate) {
			return statusOptions.partiallyPaidBeforeDueDate;
		} else {
			return statusOptions.partiallyPaidAfterDueDate;
		}
	} else if (amountAlreadyPaid > 0) {
		if (isBeforeDueDate) {
			return statusOptions.partiallyPaidBeforeDueDate;
		} else {
			return statusOptions.partiallyPaidAfterDueDate;
		}
	} else {
		if (isBeforeDueDate) {
			return statusOptions.unpaidBeforeDueDate;
		} else {
			return statusOptions.unpaidAfterDueDate;
		}
	}
}

function getStatusForFee(paymentStatus) {
	if (paymentStatus === null || paymentStatus === undefined) {
		return null;
	}

	if (enumDef.paymentStatus.isSettled(paymentStatus)) {
		return statusOptions.fullyPaid;
	} else {
		return statusOptions.unpaidBeforeDueDate;
	}
}

const paymentProgress = {
	statusOptions: statusOptions,
	getStatusForSettlement: getStatusForSettlement,
	getStatusForFee: getStatusForFee
};

export {
	paymentProgress
}